import { required } from "ra-core";
import { SelectInput } from "@/components/admin/select-input";
import { TextInput } from "@/components/admin/text-input";
import { transactionDirectionChoices } from "../shared/transactionModel";
import { CategoryIconPicker } from "./CategoryIconPicker";

export const CategoryInputs = () => (
  <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
    <TextInput source="name" validate={required()} helperText={false} />
    <SelectInput
      source="direction"
      choices={transactionDirectionChoices}
      validate={required()}
      helperText={false}
    />
    <CategoryIconPicker source="icon" />
    <TextInput source="color" helperText="#RRGGBB (optional)" />
  </div>
);
